import { useParams } from "react-router-dom"

import { PointSelectListener } from "@l2r-front/l2r-common"
import { BASE_MAP_ID } from "@l2r-front/l2r-map"

import { useVerticalSignPole } from "../../hooks/queries/verticalSigning/useVerticalSignPoles"

export function VerticalSignSelectListener() {

    const { signId: poleId } = useParams()
    const { data: poleFeature } = useVerticalSignPole(poleId, { as_geojson: true })

    return <PointSelectListener mapId={BASE_MAP_ID} pointFeature={poleFeature} />
}
